import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const HousePerson = t0 => {
  const $ = _c(10);
  let props;
  let strokeWidthProp;
  if ($[0] !== t0) {
    ({
      strokeWidth: strokeWidthProp,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = strokeWidthProp;
  } else {
    props = $[1];
    strokeWidthProp = $[2];
  }
  const t1 = strokeWidthProp ?? 1.2;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path d="M6.10001 16.4791H4.26667C2.24163 16.4791 0.600006 14.8375 0.600006 12.8125V7.04443C0.600006 5.76227 1.26973 4.57324 2.36623 3.90869L6.94956 1.13092C8.11768 0.422995 9.58233 0.422995 10.7504 1.13092L15.3338 3.90869C16.4303 4.57324 17.1 5.76227 17.1 7.04443V12.8125C17.1 14.8375 15.4583 16.4791 13.4333 16.4791H11.6M6.10001 16.4791V12.8125C6.10001 11.2936 7.33118 10.0625 8.85001 10.0625C10.3688 10.0625 11.6 11.2936 11.6 12.8125V16.4791M6.10001 16.4791H11.6H6.10001Z" fill="black" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = strokeWidthProp ?? 1.2;
  let t4;
  if ($[4] !== t3) {
    t4 = <path d="M6.10001 16.4791H4.26667C2.24163 16.4791 0.600006 14.8375 0.600006 12.8125V7.04443C0.600006 5.76227 1.26973 4.57324 2.36623 3.90869L6.94956 1.13092C8.11768 0.422995 9.58233 0.422995 10.7504 1.13092L15.3338 3.90869C16.4303 4.57324 17.1 5.76227 17.1 7.04443V12.8125C17.1 14.8375 15.4583 16.4791 13.4333 16.4791H11.6M6.10001 16.4791V12.8125C6.10001 11.2936 7.33118 10.0625 8.85001 10.0625C10.3688 10.0625 11.6 11.2936 11.6 12.8125V16.4791M6.10001 16.4791H11.6" stroke="white" strokeWidth={t3} strokeLinecap="round" strokeLinejoin="round" />;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== props || $[7] !== t1 || $[8] !== t4) {
    t5 = <IconWrapper {...props} variant="hybrid" viewBox="0 0 18 18" strokeWidth={t1}>{t2}{t4}</IconWrapper>;
    $[6] = props;
    $[7] = t1;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
export { HousePerson };